// Swedish-week date helpers, extracted verbatim from the events app's EventCalendar so
// the recruitment app's interview calendar doesn't fork a second copy. Weeks start on
// Monday everywhere (getDay() is Sunday-based, hence the shifting in startOfWeek and in
// WEEKDAY_LABELS_*).

export const WEEKDAY_LABELS_WORKWEEK = ['Mån', 'Tis', 'Ons', 'Tors', 'Fre']
export const WEEKDAY_LABELS_FULL     = ['Mån', 'Tis', 'Ons', 'Tors', 'Fre', 'Lör', 'Sön']
export const MONTH_LABELS = ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december']

export const startOfWeek = (date) => {
  const d = new Date(date)
  const day = d.getDay() // 0=Sun..6=Sat
  const diff = (day === 0 ? -6 : 1) - day
  d.setDate(d.getDate() + diff)
  d.setHours(0, 0, 0, 0)
  return d
}

export const addDays = (date, n) => {
  const d = new Date(date)
  d.setDate(d.getDate() + n)
  return d
}

export const startOfMonth = (date) => {
  const d = new Date(date.getFullYear(), date.getMonth(), 1)
  d.setHours(0, 0, 0, 0)
  return d
}

export const addMonths = (date, n) => new Date(date.getFullYear(), date.getMonth() + n, 1)

export const isSameDay = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()

export const dateOnly = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate())

export const formatTime = (iso) => new Date(iso).toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit' })

export const monthLabel = (anchor) => `${MONTH_LABELS[anchor.getMonth()]} ${anchor.getFullYear()}`

// The full 7-column grid the month view renders: whole weeks, so it starts on the Monday
// on or before the 1st and ends on the Sunday on or after the last day of the month. This
// range — not the month itself — is what a caller should fetch, or the leading/trailing
// days of the grid come up empty.
export const monthGridRange = (anchor) => {
  const monthStart = startOfMonth(anchor)
  const monthEnd   = addMonths(anchor, 1)
  const start = startOfWeek(monthStart)
  let end = start
  while (end < monthEnd) end = addDays(end, 7)
  return { start, end }
}

export const monthGridDays = (anchor) => {
  const { start, end } = monthGridRange(anchor)
  const days = []
  for (let d = start; d < end; d = addDays(d, 1)) days.push(d)
  return days
}
